const warningHandling = {
	state: () => ({
		warningMessage: '',
		code: 0
	}),
	getters: {
		getWarningMessage: state => state.warningMessage,
		isWarning: state => !!state.warningMessage
	},
	mutations: {
		setWarningMessage(state, payload) {
			state.warningMessage = payload;
		},
		reset(state) {
			state.warningMessage = "";
		}
	},
	actions: {
		resetWarnings({commit}) {
			commit("reset");
		},
		setWarning({commit}, warning) {
			if(warning.status === 201 && warning.data.emailAddress){
				commit("setWarningMessage", "Het e-mail adres is opgeslagen: " + warning.data.emailAddress);
			} else if (warning.status === 208) {
				commit("setWarningMessage", warning.statusText !== "" ? warning.statusText : "Deze gegevens zijn al geregistreerd.");
			}
		}
	}
};
export default warningHandling;
